import "./style.css";

const About = () => {
  return (
    <div className="works">
      <h1>Experiences</h1>
      <p>Project: Covid19 Tracker</p>
      <p>Role: Front-end</p>
      <p>Date: 2021</p>
      <p>
       
         <li>Used React.js for the front-end development</li>
         <li>Material UI for the Cards representation</li>
         <li>Chart.js for the use of visualization</li>
         <li>Shows the active, recovered, and deaths numbers caused by Covid19 Virus</li>
       
       </p>
      <br />
      <p>Project: Music Player</p>
      <p>Role: Front-end</p>
      <p>Date: 2021</p>
      
         <li>Used React.js for the front-end development</li>
         <li>Features: Forward, backward, pause and play for the songs</li>
         <li>Used react icons for the use of button controls</li>
         <li>Tried to make it responsive</li>
       
      <br />
      <p>Project: Portfolio</p>
      <p>Role: Front-end</p>
      <p>Date: 2021</p>
      <p>
        Tried to create Portfolio using react libraries including react routing and the html,css & JavaScript technologies used for the front end developemt. This site is the same Portfolio.
      </p>

    </div>
  );
};

export default About;